import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

class Button extends PureComponent {
  render() {
    const {
      children,
      primary,
      secondary,
      outline,
      large,
      fill,
      onClick,
      disabled,
      className,
      type,
      to,
    } = this.props;

    const classes = classNames(
      'btn',
      {
        'btn-primary': primary,
        'btn-secondary': secondary,
        'btn-outline-primary': primary && outline,
        'btn-outline-secondary': secondary && outline,
        'btn-block': fill,
        'btn-lg': large,
      },
      className
    );

    return to ? (
      <Link to={to} className={classes}>
        {children}
      </Link>
    ) : (
      <button
        type={type || 'button'}
        className={classes}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </button>
    );
  }
}

Button.defaultProps = {
  primary: true,
};

export default Button;
